import { render } from "./S154386.vue?vue&type=template&id=7e3f8fa2"
const script = {}
script.render = render

export default script